import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Park } from '../models/park';
import { AuthService } from '../auth-n-routing/auth-service.service';
import {BusyServices} from '../commons/busy.service';
import {ParkType} from '../models/parkType';

@Injectable()
export class ParksHandlerService {

	private getByAdminIDURI = 'parks/getByAdminID';
	private getParkByNameURI = 'parks/getByName';
	private getByTravelIDURI = 'parks/getByTravelID';
	private getAllParksURI = 'parks/all';
	private createParkURI = 'parks/create';
	private getParkTypesURI = 'parks/getParkTypes';

	constructor(private busy: BusyServices, private http: HttpClient, private authService: AuthService) { }

	getByAdminID(): Promise<Park[]> {
		return new Promise<Park[]>((resolve, reject) => {
			const _http = this.http.post(environment.api.baseUrl + this.getByAdminIDURI,
				{ 'id': this.authService.user.id.toString() }, environment.api.config).subscribe(
				(data: any) => {
					const toRet = [];
					console.log(data);
					if (data.data) {
						data.data.forEach((park_server_obj) => {
							const park_raw = park_server_obj['park'];
							toRet.push(new Park(park_raw));
						});
					}
					resolve(toRet);
				});
			this.busy.setBusy(_http);
		});
	}

	getParkByName(park_name: string): Promise<Park> {
		return new Promise<Park>((resolve, reject) => {

			const body = {
				'name': park_name
			};

			const _http = this.http.post(environment.api.baseUrl + this.getParkByNameURI, body,
				environment.api.config).subscribe(
				(data: any) => {

					if (data.park) {
						resolve(new Park(data.park));
					} else {
						resolve(new Park(undefined));
					}

				});
			this.busy.setBusy(_http);
		});
	}

	getByTravelID(travelID: string): Promise<Park> {
		return new Promise<Park>((resolve, reject) => {

			const body = {
				'travelID': travelID
			};

			const _http = this.http.post(environment.api.baseUrl + this.getByTravelIDURI, body,
				environment.api.config).subscribe(
				(data: any) => {

					if (data['data'][0].park) {
						resolve(new Park(data['data'][0].park));
					} else {
						resolve(new Park(undefined));
					}

				});
			this.busy.setBusy(_http);
		});
	}

	getAllParks(): Promise<Park[]> {
		return new Promise<Park[]>((resolve, reject) => {

			const _http = this.http.post(environment.api.baseUrl + this.getAllParksURI, {},
				environment.api.config).subscribe(
				(data: any) => {

					const toRet = [];
					if (data.data) {
						data.data.forEach((vehicle_server_obj) => {
							const park_raw = vehicle_server_obj['park'];
							toRet.push(new Park(park_raw));
						});
					}

					resolve(toRet);

				});
			this.busy.setBusy(_http);
		});
	}
	
	
	getParkTypes(): Promise<ParkType[]> {
		return new Promise<ParkType[]>((resolve, reject) => {

			const _http = this.http.post(environment.api.baseUrl + this.getParkTypesURI, {},
				environment.api.config).subscribe(
				(data: any) => {

					const toRet = [];
					if (data.data) {
						data.data.forEach((parkType) => {
							const parkTypeRaw = parkType['parkType'];
							toRet.push(new ParkType(parkTypeRaw));
						});
					}

					resolve(toRet);

				});
			this.busy.setBusy(_http);
		});
	}
	
	createPark(name: string, type: number): Promise<Park> {
		return new Promise<Park>((resolve, reject) => {
			
			const _http = this.http.post(environment.api.baseUrl + this.createParkURI,
				{name, type},
				environment.api.config).subscribe(
				(data: any) => {
					if (data['park']) {
						resolve(new Park(data['park']));
					} else {
						resolve(new Park(undefined));
					}
				},
				err => {
					reject();
				});
			this.busy.setBusy(_http);
		});
	}
}
